type NullableNumber = number | null | undefined;

export const gt = (a: NullableNumber, b: NullableNumber): boolean =>
  a !== null && a !== undefined && b !== null && b !== undefined && a > b;

export const gte = (a: NullableNumber, b: NullableNumber): boolean =>
  a !== null && a !== undefined && b !== null && b !== undefined && a >= b;

export const lt = (a: NullableNumber, b: NullableNumber): boolean =>
  a !== null && a !== undefined && b !== null && b !== undefined && a < b;

export const lte = (a: NullableNumber, b: NullableNumber): boolean =>
  a !== null && a !== undefined && b !== null && b !== undefined && a <= b;
